// Проверить, является ли номер телефона валидным
// number: string
export default function isPhoneNumberValid(number) {
  return /^[78]9\d{9}$/.test(number);
}
